import PropTypes from "prop-types";
import React from "react";
import Popup from "reactjs-popup";
import ChevronDownIcon from "../../shared/Icons/ChevronDownIcon";

const notesMenuStyle = {
  border: "1px solid var(--sl-border-primary)",
  borderRadius: "8px",
  boxShadow: "var(--sl-shadow-sm)",
  width: "260px",
  padding: "0px",
  background: "var(--sl-bg-primary)",
  color: "var(--sl-text-primary)",
};

const NotesPicker = ({ notes, selectedNoteIds, onToggle }) => (
  <div className="sl-notes-picker">
    <span style={{ fontSize: "13px", lineHeight: "18px", color: "var(--sl-text-secondary)" }}>
      Notes to include <span style={{ color: "var(--sl-text-quaternary)" }}>({selectedNoteIds.length} selected)</span>
    </span>
    <Popup arrow={false} offsetY={-10} offsetX={1} position="bottom right" contentStyle={notesMenuStyle}
           onOpen={(e) => { e.stopPropagation(); e.preventDefault(); }}
           trigger={
             <button type="button" className="sl-notes-picker-trigger">
               Choose <ChevronDownIcon fill="var(--sl-text-brand)" width="14" height="14" />
             </button>
           }>
      {() => (
        <div style={{ padding: "8px", display: "flex", flexDirection: "column", gap: "2px", maxHeight: "220px", overflowY: "auto" }}>
          {notes.map((note) => (
            <label key={note.id} className="sl-notes-picker-item">
              <input type="checkbox" checked={selectedNoteIds.some((noteId) => noteId === note.id)}
                     onChange={() => onToggle(note.id)} />
              {note.title}
            </label>
          ))}
        </div>
      )}
    </Popup>
  </div>
);

NotesPicker.propTypes = {
  notes: PropTypes.array.isRequired,
  selectedNoteIds: PropTypes.array.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default NotesPicker;
